import {copyRequestWithUrl} from "./copy-request-with-url.ts";
import {getUpdatedUrlAndHeaders} from "./get-updated-url-and-headers.ts";

/**
 * Update URL query string params and headers for API requests.
 *
 * Updates the URL query string params and the headers so that the correct
 * params are passed through on API requests.
 *
 * @param request The request to update.
 * @returns A Promise that resolves to the updated request.
 */
export function addApiParamsAndHeaders(request: Request): Promise<Request> {
    // Update the URL and headers
    const {url, headers} = getUpdatedUrlAndHeaders(request.url);

    const reqHeaders = new Headers(request.headers);
    for (const {name, value} of headers) {
        reqHeaders.set(name, value);
    }

    // Build a new request using the new URL and headers
    return copyRequestWithUrl(url, new Request(request, {headers: reqHeaders}));
}
